module.exports = __webpack_public_path__ + "img/header_produkte_preislisten_1192x282.c404e168.jpg";